import Button from '@/core/components/Button/Button';

export default Button;
